/**
 * Carousel drag-to-scroll — reusable component
 * Usage: add class "js-carousel" to any horizontally-scrollable track element.
 */
(function () {
  var DRAG_THRESHOLD = 5;

  document.querySelectorAll('.js-carousel').forEach(function (track) {
    var isDown = false;
    var hasDragged = false;
    var startX;
    var scrollLeft;
    var lastX;
    var velocity = 0;
    var rafId;

    /* Block native image/link drag inside the carousel */
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      hasDragged = false;
      if (rafId) cancelAnimationFrame(rafId);
      track.classList.add('is-dragging');
      startX = e.pageX;
      lastX = e.pageX;
      scrollLeft = track.scrollLeft;
      velocity = 0;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');

      /* Momentum coast */
      if (Math.abs(velocity) > 0.5) {
        coast();
      }
    }

    function coast() {
      velocity *= 0.92;
      if (Math.abs(velocity) < 0.5) {
        velocity = 0;
        return;
      }
      track.scrollLeft -= velocity;
      rafId = requestAnimationFrame(coast);
    }

    track.addEventListener('mouseleave', endDrag);
    track.addEventListener('mouseup', endDrag);

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX;
      var walk = x - startX;
      velocity = x - lastX;
      lastX = x;
      if (Math.abs(walk) > DRAG_THRESHOLD) {
        hasDragged = true;
      }
      track.scrollLeft = scrollLeft - walk;
    });

    /* Prevent click (navigation) if user was dragging, not clicking */
    track.addEventListener('click', function (e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }
    }, true);
  });
})();
